import { createSlice } from "@reduxjs/toolkit";

export const selectedBranch = createSlice({
  name: "selectedBranch",
  initialState: {
    selectedBranch: null,
  },
  reducers: {
    setSelectedBranch: (state, action) => {
      state.selectedBranch = action.payload;
    },
  },
});

export const { setSelectedBranch } = selectedBranch.actions;

export default selectedBranch.reducer;
